import React from 'react';
import { ApiEndpoint } from '../components/api/ApiEndpoint';
import { accountEndpoints } from '../data/apiData';

export const AccountManagement: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Account Management</h1>
        <p className="text-lg text-gray-500 mb-6">
          Access detailed information about your reserve accounts and check account balances. 
          Essential tools for account verification, balance monitoring, and financial oversight.
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <div className="bg-indigo-500/10 border border-indigo-500/30 rounded-lg p-6">
            <h3 className="text-lg font-semibold text-indigo-500 mb-3">Reserve Account Details</h3>
            <p className="text-sm text-indigo-500/90 mb-3">
              Retrieve complete information about reserve accounts including account holder details and status.
            </p>
            <ul className="text-xs text-indigo-500/80 space-y-1">
              <li>• Account holder name verification</li>
              <li>• Account number confirmation</li>
              <li>• Account status monitoring (ACTIVE/INACTIVE)</li>
              <li>• Current account balance</li>
              <li>• Account type identification</li>
            </ul>
          </div>
          
          <div className="bg-teal-500/10 border border-teal-500/30 rounded-lg p-6">
            <h3 className="text-lg font-semibold text-teal-500 mb-3">Account Balance Checks</h3>
            <p className="text-sm text-teal-500/90 mb-3">
              Quick balance verification for any account using just the account number. Simple and efficient.
            </p>
            <ul className="text-xs text-teal-500/80 space-y-1">
              <li>• Instant balance retrieval</li>
              <li>• Lightweight API calls</li>
            </ul>
          </div>
        </div>

        {/* <div className="bg-white border border-gray-200 rounded-lg p-6 mb-8">
          <h3 className="text-lg font-semibold text-gray-900 mb-3">Account Balance Components</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
            <div>
              <div className="text-lg font-bold text-green-600 mb-1">Available Balance</div>
              <div className="text-xs text-gray-500">Immediately accessible funds</div>
            </div>
            <div>
              <div className="text-lg font-bold text-blue-600 mb-1">Overdraft Limit</div>
              <div className="text-xs text-gray-500">Additional credit available</div>
            </div>
            <div>
              <div className="text-lg font-bold text-purple-600 mb-1">Commission</div>
              <div className="text-xs text-gray-500">Earned commission balance</div>
            </div>
            <div>
              <div className="text-lg font-bold text-orange-600 mb-1">Rebate Points</div>
              <div className="text-xs text-gray-500">Loyalty points balance</div>
            </div>
          </div>
        </div> */}

        <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-4 mb-8">
          <h3 className="text-sm font-semibold text-blue-500 mb-2">Best Practices</h3>
          <ul className="list-disc list-inside text-sm text-blue-500/90 space-y-1">
            <li>Check account balance before initiating transfers to avoid insufficient funds</li>
            <li>Use account number validation to prevent errors in financial operations</li>
            <li>Keep account queries lightweight for better system performance</li>
          </ul>
        </div>
      </div>

      <div className="space-y-8">
        {accountEndpoints.map((endpoint) => (
          <ApiEndpoint key={endpoint.id} endpoint={endpoint} />
        ))}
      </div>
    </div>
  );
};